<template>
  <section class="screenshots">
    <div class="main-container">
      <p class="screenshots__header">
        <span class="line"
          >Explore a randomly generated map and scavenge for food, ammo and
          supplies.</span
        >
        <span class="line"
          >Use anything you find to craft advanced items. Protect yourself
          against aggressive infected and ferocious wolves.</span
        >
        <span class="line"
          >But most important of all: make sure to stay dry, warm and well fed
          at all times. The weather out there can</span
        >
        <span class="line"
          >quickly get under your skin and your wounds will not heal without you
          treating them…</span
        >
      </p>
      <ScreenshotSlider />
    </div>
  </section>
</template>
<script>
import Slick from "vue-slick";
import AwesomeSlider from "../AwesomeSlider";
import ScreenshotSlider from "./ScreenshotSlider";

export default {
  components: {
    slick: Slick,
    AwesomeSlider,
    ScreenshotSlider
  },
  data() {
    return {
      options: {
        arrows: true,
        dots: true,
        nextArrow: `<span class="next slick-arrow" style=""><span class="iconmoon-rightarrow"></span></span>`,
        prevArrow: `<span class="prev slick-arrow" style=""><span class="iconmoon-leftarrow"></span></span>`
      }
    };
  },
  methods: {}
};
</script>
